import { connect } from "react-redux"
import Route from "misago/components/threads/route"
import misago from "misago/index"

export function getSelect(options) {
  return function (store) {
    return {
      options: options,
      selection: store.selection,
      threads: store.threads,
      tick: store.tick.tick,
      user: store.auth.user,
    }
  }
}

export function getLists(user) {
  let lists = [
    {
      type: "all",
      path: "",
      name: pgettext("zones list", "All"),
      longName: gettext("All zones"),
    },
  ]

  if (user.id) {
    lists.push({
      type: "my",
      path: "my/",
      name: pgettext("zones list", "My"),
      longName: pgettext("zones list", "My zones"),
    })
    lists.push({
      type: "new",
      path: "new/",
      name: pgettext("zones list", "New"),
      longName: pgettext("zones list", "New zones"),
    })
    lists.push({
      type: "unread",
      path: "unread/",
      name: pgettext("zones list", "Unread"),
      longName: pgettext("zones list", "Unread zones"),
    })
    lists.push({
      type: "watched",
      path: "watched/",
      name: pgettext("zones list", "Watched"),
      longName: pgettext("zones list", "Watched zones"),
    })

    if (user.acl.can_see_unapproved_content_lists) {
      lists.push({
        type: "unapproved",
        path: "unapproved/",
        name: pgettext("zones list", "Unapproved"),
        longName: pgettext("zones list", "Unapproved content"),
      })
    }
  }

  return lists
}

export function paths(user, mode) {
  let lists = getLists(user)
  let routes = []
  let categoriesMap = {}

  misago.get("CATEGORIES").forEach(function (category) {
    lists.forEach(function (list) {
      categoriesMap[category.id] = category

      routes.push({
        path: category.url.index + list.path,
        component: connect(getSelect(mode))(Route),

        categories: misago.get("CATEGORIES"),
        categoriesMap,
        category,

        lists,
        list,
      })
    })
  })

  return routes
}
